import * as React from 'react'
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout'
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar'
import CadastroProfessorForm from './CadastroProfessorForm'

export default function CadastroScreen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CadastroProfessorForm />
    </DashboardLayout>
  )
}
